import {createGlobalStyle} from "styled-components";

interface IGlobalStyleProps {
  customStyle?: string;
}

const GlobalStyle = createGlobalStyle<IGlobalStyleProps>`

    ${(props) => props.customStyle && props.customStyle}

`;

export default GlobalStyle;
